import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import type { NotificationProps } from 'redux-store/slices/notifications/types';

import { Notification } from './notification';

export const Notifications: React.FC<{
  notifications: NotificationProps[];
}> = ({ notifications }) => {
  const [isRender, setIsRender] = useState(false);

  useEffect(() => {
    setIsRender(true);
  }, []);

  if (!isRender) {
    return null;
  }

  const notes = notifications.map(el => <Notification key={el.id} {...el} />);

  return createPortal(notes, document.body);
};
